module.exports = __webpack_public_path__ + "static/media/pay-paypal.952c0a4b.png";